import { render, staticRenderFns } from "./romaplus.vue?vue&type=template&id=6fe35d09&scoped=true"
import script from "./romaplus.vue?vue&type=script&lang=js"
export * from "./romaplus.vue?vue&type=script&lang=js"
import style0 from "./romaplus.vue?vue&type=style&index=0&id=6fe35d09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe35d09",
  null
  
)

export default component.exports